module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2jDEh"))).then(() => parcelRequire('ljYL6'));